import { render, staticRenderFns } from "./VehicleSelect.vue?vue&type=template&id=36c654bb&scoped=true&"
import script from "./VehicleSelect.vue?vue&type=script&lang=js&"
export * from "./VehicleSelect.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSelect.vue?vue&type=style&index=0&id=36c654bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c654bb",
  null
  
)

export default component.exports